
<ng-template let-entity="entity" #actionsTemplate>
  <div class="btn-group" role="group" aria-label="Basic example">
    <button [routerLink]="['edit', entity.getPrimaryKey()]" [queryParams]="{sort: sortParam}"
            class="btn btn-sm btn-outline-dark" ngbTooltip="Hersteller bearbeiten" i18n-ngbTooltip="@@EditManufacturerTooltip" placement="left">
      <span data-bs-toggle="modal" data-bs-target="#stationEdit">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="feather feather-edit">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
      </span>
    </button>
    <button [routerLink]="['delete', entity.getPrimaryKey()]" [queryParams]="{sort: sortParam}"
            class="btn btn-sm btn-outline-danger" ngbTooltip="Hersteller löschen" i18n-ngbTooltip="@@DeleteManufacturerTooltip" placement="left">
      <span data-bs-toggle="modal" data-bs-target="#stationDelete">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
      </span>
    </button>
  </div>
</ng-template>

<main id="manufacturer-table">
  <div class="card">
    <div class="card-header">
      <div class="row card-title">
        <div class="col-12">
          <h5 class="m-0 p-0">
            <span class="float-start" i18n="@@CustomerOverviewHeader"> <app-svg source="icons/feather/zap" height="18" class="me-2"></app-svg> Hersteller ({{ tableFunctions.total$ | async }})</span>
          </h5>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="clearfix">

        <div class="float-end">
          <button class="btn btn-yellow ms-1" id="create_manufacturer" [routerLink]="['create']" i18n-ngbTooltip="@@AddNewManufacturerTooltip" ngbTooltip="Neuen Hersteller anlegen">
            <app-svg source="icons/feather/plus" height="18"></app-svg>
            <span class="d-none d-md-inline ps-2" i18n="@@AddNewManufacturer">Hersteller anlegen</span>
          </button>
          <button class="btn btn-yellow ms-1" id="card_list_view_toggle"
                  (click)="tableFunctions.toggleTableLayout(className, className + 'Table', $event.target)"
                  [innerHTML]="sanitizer.bypassSecurityTrustHtml(tableFunctions.getTableLayoutCaption(className))">
          </button>
        </div>
        </div>
        <div *ngIf="tableReady" [class]="tableView">
          <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()" [class]="tableFunctions.getTableLayout(className)"></app-table>
        </div>

        <div *ngIf="!tableReady" class="loading-spinner-container">
          <div class="spinner-border text-primary loading-spinner-md" role="status">
            <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
          </div>
        </div>
      </div>

      <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
        <div class="d-flex">
          <div class="flex-fill d-none d-md-inline">
            <div class="d-flex">
              <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
              <div class="flex">
                <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                        class="form-control form-select custom-select" aria-label=""
                        (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                  <option [ngValue]="250">250</option>
                </select>
              </div>
            </div>
          </div>

          <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
            <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                            [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                            [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
            </ngb-pagination>
          </div>

          <div class="flex-fill justify-content-end d-none d-md-inline">
            <div class="d-flex float-end">
              <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
              <div class="flex">
                <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                        aria-label="">
                  <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                          [ngValue]="i + 1">
                    {{ i + 1 }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</main>
<router-outlet></router-outlet>



